import { render, staticRenderFns } from "./balance___.vue?vue&type=template&id=24cfaf73&"
import script from "./balance___.vue?vue&type=script&lang=js&"
export * from "./balance___.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports